import { Box, Paper, Typography, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';

const PageHeaderCard = ({
    title,
    subtitle,
    icon,
    actions,
    titleSuffix,
    titleVariant = 'h4',
    titleFontWeight = 600,
    mb = 4,
}) => {
    const theme = useTheme();

    return (
        <Paper
            variant="outlined"
            sx={{
                mb,
                p: { xs: 2, sm: 3 },
                borderRadius: 2,
                borderColor: alpha(theme.palette.primary.main, 0.16),
                background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.08)} 0%, ${alpha(theme.palette.background.paper, 0.95)} 60%)`,
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: { xs: 'flex-start', sm: 'center' },
                    justifyContent: 'space-between',
                    flexDirection: { xs: 'column', md: 'row' },
                    gap: 2,
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    {icon && (
                        <Box
                            sx={{
                                width: { xs: 46, sm: 54 },
                                height: { xs: 46, sm: 54 },
                                borderRadius: 2,
                                bgcolor: alpha(theme.palette.primary.main, 0.14),
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                            }}
                        >
                            {icon}
                        </Box>
                    )}

                    <Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                            <Typography variant={titleVariant} fontWeight={titleFontWeight}>
                                {title}
                            </Typography>
                            {titleSuffix}
                        </Box>
                        {subtitle && (
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                                {subtitle}
                            </Typography>
                        )}
                    </Box>
                </Box>

                {actions && <Box sx={{ width: { xs: '100%', md: 'auto' } }}>{actions}</Box>}
            </Box>
        </Paper>
    );
};

export default PageHeaderCard;